module.exports = __webpack_public_path__ + "img/brand_poweredby.b65125ac.svg";